import { Label, Layout, Panel } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { ImageName } from "@mcleod/images";
import { DemoDefinition } from "../DemoDefinition";
import { DemoRegistry } from "../DemoRegistry";


export class DemoMessageDialog extends Layout {
    buttonSimpleClicked() {
        CommonDialogs.showMessage("Test");
    }

    buttonPropsClicked() {
        CommonDialogs.showMessage({ text: "Document saved.", imageName: ImageName.disk, fontBold: true });
    }

    buttonComponentClicked() {
        const panel = new Panel();
        const label = new Label({ text: "You have been logged out.", imageName: ImageName.person, fontBold: true });
        const link = new Label({ text: "Go to login page", link: "/common/Login" });
        panel.add(label);
        panel.add(link);
        CommonDialogs.showMessage(panel);
    }
}
DemoRegistry.get().register(new DemoDefinition("dialogs/DemoMessageDialog", [ "Dialogs", "Messages" ]));
